import React, { useState } from 'react';
import { Layout, Drawer, Menu } from 'antd';
import { MenuOutlined, DashboardOutlined, AppstoreOutlined, ShoppingOutlined, UserOutlined, SettingOutlined, HeartOutlined, MailOutlined, ShopOutlined, TeamOutlined, TrophyOutlined, UnorderedListOutlined, FileTextOutlined, ExclamationCircleOutlined, BellOutlined } from '@ant-design/icons';
import SideMenu from './SideMenu';
import './DashboardLayout.css';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const { Content, Sider } = Layout;

const DashboardLayout = ({ children }) => {
    const [mobileMenuVisible, setMobileMenuVisible] = useState(false);
    const location = useLocation();
    const { currentUser } = useSelector((state) => state.user);
    const isAdmin = currentUser?.roles?.includes('admin');
    const isDisputesPage = location.pathname.startsWith('/disputes');
    const isFeedbackPage = location.pathname.startsWith('/feedback');

    // Get the current path to determine which menu items should be open
    const getOpenKeys = () => {
        const path = location.pathname;
        const openKeys = [];
        
        if (path.startsWith('/favorite-')) {
            openKeys.push('favorites');
        }
        
        if (path.startsWith('/invitations')) {
            openKeys.push('invitations');
        }
        
        return openKeys;
    };

    const menuItems = [
        {
            key: 'dashboard',
            icon: <DashboardOutlined />,
            label: <Link to="/dashboard">Dashboard</Link>
        },
        {
            key: 'my-auctions',
            icon: <AppstoreOutlined />,
            label: <Link to="/my-auctions">My Auctions</Link>
        },
        {
            key: 'my-lots',
            icon: <ShoppingOutlined />,
            label: <Link to="/my-lots">My Lots</Link>
        },
    
        {
            key: 'invitations',
            icon: <MailOutlined />,
            label: 'Invitations',
            children: [
                {
                    key: 'pending-invitations',
                    label: <Link to="/invitations">Pending Invitations</Link>
                },
                {
                    key: 'accepted-invitations',
                    label: <Link to="/invitations/accepted">Accepted Invitations</Link>
                },
                {
                    key: 'sent-invitations',
                    label: <Link to="/invitations/sent">Sent Invitations</Link>
                }
            ]
        },
        {
            key: 'favorites',
            icon: <HeartOutlined />,
            label: 'Favorites',
            children: [
                {
                    key: 'favorite-auctions',
                    label: <Link to="/favorite-auctions">Favorite Auctions</Link>
                },
                {
                    key: 'favorite-lots',
                    label: <Link to="/favorite-lots">Favorite Lots</Link>
                }
            ]
        },
        {
            key: 'achievements',
            icon: <TrophyOutlined />,
            label: <Link to="/achievements">Achievements</Link>
        },
        {
            key: 'notifications',
            icon: <BellOutlined />,
            label: <Link to="/notifications">Notifications</Link>
        },
        // {
        //     key: 'disputes',
        //     icon: <ExclamationCircleOutlined />,
        //     label: <Link to="/disputes">Disputes</Link>
        // },
        {
            key: 'profile',
            icon: <UserOutlined />,
            label: <Link to="/profile">Profile</Link>
        },
        {
            key: 'company',
            icon: <ShopOutlined />,
            label: <Link to="/company">Company Information</Link>
        },
        {
            key: 'agents',
            icon: <TeamOutlined />,
            label: <Link to="/agents">Agents</Link>
        },
        // {
        //     key: 'settings',
        //     icon: <SettingOutlined />,
        //     label: <Link to="/settings">Settings</Link>
        // }
    ];

    return (
        <Layout style={{ minHeight: '100vh', background: '#fff' }}>
            {/* Desktop Sidebar - Only show for non-admin users and not on disputes/feedback pages */}
            {!isAdmin && !isDisputesPage && !isFeedbackPage && (
                <Sider 
                    width={200} 
                    style={{ background: '#fff' }}
                    className="d-none d-lg-block"
                >
                    <SideMenu menuItems={menuItems} defaultOpenKeys={getOpenKeys()} />
                </Sider>
            )}

            <Content className="dashboard-content">
                {/* Mobile Menu Icon - Only show for non-admin users and not on disputes/feedback pages */}
                {!isAdmin && !isDisputesPage && !isFeedbackPage && (
                    <div className="d-lg-none mb-3">
                        <MenuOutlined 
                            onClick={() => setMobileMenuVisible(true)}
                            style={{
                                fontSize: '24px',
                                cursor: 'pointer'
                            }}
                        />
                    </div>
                )}

                {children}
            </Content>

            {/* Mobile Drawer Menu - Only show for non-admin users and not on disputes/feedback pages */}
            {!isAdmin && !isDisputesPage && !isFeedbackPage && (
                <Drawer
                    placement="left"
                    onClose={() => setMobileMenuVisible(false)}
                    open={mobileMenuVisible}
                    width={280}
                    className="d-lg-none"
                >
                    <SideMenu menuItems={menuItems} defaultOpenKeys={getOpenKeys()} />
                </Drawer>
            )}
        </Layout>
    );
};

export default DashboardLayout; 